import API from "./API";
const API_URL = window.ENV.WEB_API_URL;

export default class ContractAggregateAPI extends API {
  constructor(parameters = {}) {
    super("/ContractAggregate", parameters);
  }
    createContract(data) {
    return this.submit("post", `${this.endpoint}`, data);
  }

  updateContract(data, id) {
    return this.submit("put", `${this.endpoint}?id=${id}`, data);
  }
  async changeContractStatus(requestData){
    return await this.submit("post", `${this.endpoint}/ChangeContractStatus`, requestData);
  }

  updateContractSimplified(data, id) {
    return this.submit("put", `${API_URL}/api/ContractAggregateWithEvents?id=${id}`, data);
  }

  getContractById(id) {
    return this.submit("get", `${this.endpoint}/${id}`);
  }

  getContractByIdAndEventId(data) {
    return this.submit("get", `${this.endpoint}/${data.id}?eventId=${data.eventId}`);
  }

  getContracts(filterData) {
    let url = `${this.endpoint}/Get`;
    let urlParams = '?';

    if (filterData == null) {
      return this.submit("get", url);
    } else {
      for (let key in filterData) {
        if (filterData.hasOwnProperty(key) && filterData[key] != null) {
          urlParams += `${key}=${filterData[key]}&`;
        }
      }

      urlParams = urlParams.slice(0, -1);
      return this.submit("get", `${url}${urlParams}`);
    }
  }

  getCount(filterData) {
    let url = `${this.endpoint}/getCount`;
    let urlParams = '?';

    if (filterData == null) {
      return this.submit("get", url);
    } else {
      for (let key in filterData) {
        if (filterData.hasOwnProperty(key) && filterData[key] != null) {
          urlParams += `${key}=${filterData[key]}&`;
        }
      }

      urlParams = urlParams.slice(0, -1);
      return this.submit("get", `${url}${urlParams}`);
    }
  }

  async getContractPreview(contract) {
    return await this.submit("post", `${this.endpoint}/Preview`, contract);
  }
  async initialDataContractsExport()
  {
    return await this.export("post",`${this.endpoint}/InitialDataContracts`);
  }
  async exportContractsHasNonActiveStatus(contractIds)
  {
    return await this.export("post",`${this.endpoint}/ExportContractsStatus`, contractIds);
  }
  async contractsRegistryExport(data) {
    return await this.export('post', `${this.endpoint}/ExcelRegistryExport`, data);
  }
  async getContractsFailedLessorSharesValidation() {
    return await this.export('post', `${this.endpoint}/GetContractsFailedLessorSharesValidation`);
  }
}
